import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";
import { BaseDialogActionData, ButtonColor, HorizontalListData } from "common";
import { Observable } from "rxjs";
import { AppSettings } from '../../../../app.settings';
import { AccountTransfer } from "../account-transfer.model";
import { AccountTransferSubmittedDialogAdapter } from "./account-transfer-submitted-dialog.data";
import { AccountTransferSubmittedDialogData } from "./account-transfer-submitted-dialog.model";

@Component({
    selector: 'ifp-account-transfer-submitted-dialog',
    templateUrl: './account-transfer-submitted-dialog.component.html',
    styleUrls: ['./account-transfer-submitted-dialog.component.scss'],
    providers: [AccountTransferSubmittedDialogAdapter],
    standalone: false
})
export class AccountTransferSubmittedDialogComponent implements OnInit {
  actions: BaseDialogActionData[];
  items: HorizontalListData[];

  constructor(public dialogRef: MatDialogRef<AccountTransferSubmittedDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AccountTransferSubmittedDialogData,
    public settings: AppSettings,
    private readonly adapter: AccountTransferSubmittedDialogAdapter
  ) { }

  ngOnInit(): void {
    const buttonLabel = this.data?.closeButtonLabel ? this.data?.closeButtonLabel : 'Ok';
    this.actions = [
      { actionKey: buttonLabel, label: buttonLabel, buttonColor: ButtonColor.Primary },
    ];
    this.items = this.adapter.adaptHorizontalListData(this.data);
  }

  static show(
    dialog: MatDialog,
    transferInfo: AccountTransfer,
    title: string,
    action: string,
    bankIntegrationRequired?: boolean,
    closeButtonLabel?: string
  ): Observable<any> {
    return dialog.open(AccountTransferSubmittedDialogComponent, {
      width: '510px',
      data: {
        transferInfo: transferInfo,
        title: title,
        action: action,
        bankIntegrationRequired: bankIntegrationRequired,
        closeButtonLabel: closeButtonLabel
      },
      closeOnNavigation: true,
    }).afterClosed();
  }

  onActionClicked(): void {
    this.dialogRef.close(true);
  }
}
